package com.vizio.redwolf.pay.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class RewardsResponse(
    val data: List<RewardsData>? = null,
    val totalRewardAmount: String? = null,
    val expiringSoon: Boolean? = null,
    val currentPage: Int? = null,
    val pageSize: Int? = null,
    val totalPages: Int? = null,
    val totalCount: Int? = null
)

@Serializable
@JsExport
data class RewardsData(
    val balance: String? = null,
    val expirationDate: String? = null,
    val expiringSoon: Boolean? = null,
    val appName: String? = null,
    val imageUrl: String? = null
)